import React, { Component } from 'react';
import Page from '../../../containers/page';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Input
} from 'reactstrap';

import Isvg from 'react-inlinesvg'

import ListBuilder from '../../../components/listBuilder';
import ErrorModal from '../../../components/errorModal';
import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../../../helpers/linkHelper';
import { API_ENDPOINT } from '../../../constants';
import { formValueSelector, change } from 'redux-form';  // ES6
import { connect } from 'react-redux';
import viewIcon from '../../../assets/svg/eye.svg';
import xIcon from '../../../assets/svg/x.svg';
import garbageIcon from '../../../assets/svg/garbage.svg';
import walletIcon from '../../../assets/svg/wallet.svg';
import warrning from '../../../assets/svg/warrning.svg';
import addIcon from '../../../assets/svg/add-icon-v2.svg'
import Payson from '../../../components/payson';
import Swish from '../../swish';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import PdfSave from '../../../components/pdvSave';
import InfoModal from '../../../components/infoModal';
import striptags from 'striptags';
import { Player } from "@lottiefiles/react-lottie-player";
import moment from 'moment';
import downloadIcon from '../../../assets/svg/download.svg';
import deleteDocument from '../../../assets/svg/delete-document.svg'
import saveIcon from '../../../assets/svg/save-icon.svg';


import billGrey from '../../../assets/svg/bill_grey.svg';
import infoIcon from "../../../assets/svg/link-new-tab.svg";
import DatePicker from '../../../components/forms/fields/datePicker';
import Checkbox from '../../../components/forms/fields/checkbox';
import DeleteModal from '../../../components/deleteModal';
import PatientNotesPreview from '../../../components/patientNotesPreview';
import { fi, id, th } from 'react-date-range/dist/locale';
import CustomCalendarFilterSelect from '../../calendar/customCalendarFilterSelect';


function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}
function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
class CustomFilters extends Component {
    constructor(props) {
        super(props);

        this.dropdownRef = React.createRef();
        this.showFilterRef = React.createRef();

        this.state = {
            ...props.initialData,
            filters: [],
            statuses: [
                { _id: 'unpaid', label: 'Unpaid'.translate(this.props.lang) },
                { _id: 'paid', label: 'Paid'.translate(this.props.lang) },
                // { _id: 'refunded', label: 'Refunded'.translate(this.props.lang) },
                // { _id: 'partially_refunded', label: 'Partially Refunded'.translate(this.props.lang) },
                // { _id: 'refund_requested', label: 'Refund Requested'.translate(this.props.lang) },
                { _id: 'payment_cancelled', label: 'Payment cancelled'.translate(this.props.lang) },
                { _id: 'case_cancelled', label: 'Case cancelled'.translate(this.props.lang) }
            ],
            visitStatuses: [
                { _id: 'scheduled', label: 'Scheduled'.translate(this.props.lang) },
                { _id: 'revisit-scheduled', label: 'Revisit scheduled'.translate(this.props.lang) },
                { _id: 'visit-rescheduled', label: 'Visit rescheduled'.translate(this.props.lang) },
                { _id: 'in-progress', label: 'In progress'.translate(this.props.lang) },
                { _id: 'waiting', label: 'Waiting'.translate(this.props.lang) },
                { _id: 'waiting-for-approval', label: 'Waiting for approval'.translate(this.props.lang) },
                { _id: 'allowed', label: 'Allowed'.translate(this.props.lang) },
                { _id: 'disallowed', label: 'Disallowed'.translate(this.props.lang) },
                { _id: 'canceled-by-clinic', label: 'Cancelled by clinician'.translate(this.props.lang) },
                { _id: 'patient-rejected', label: 'Cancelled by patient'.translate(this.props.lang) },
                { _id: 'requested-new-appointment', label: 'Requested new appointment'.translate(this.props.lang) },
                { _id: 'closed', label: 'Closed'.translate(this.props.lang) }
            ],
            paymentMethods: [
                // { _id: 'onlinePayment', label: 'Online payment'.translate(this.props.lang) },
                { _id: 'invoice', label: 'Invoice - sent/paid'.translate(this.props.lang) },
                { _id: 'invoiceRequested', label: 'Invoice Requested'.translate(this.props.lang) },
                // { _id: 'invoicePending', label: 'Invoice - Pending'.translate(this.props.lang) },
                { _id: 'paymentOnSite', label: 'Payment on site'.translate(this.props.lang) },
                { _id: 'paymentOnSitePending', label: 'Payment on site - Pending'.translate(this.props.lang) },
                { _id: 'freeCard', label: 'Free card'.translate(this.props.lang) },
                { _id: 'freeCardPending', label: 'Free card - Pending'.translate(this.props.lang) },
                { _id: 'freeOfCharge', label: 'Free of charge'.translate(this.props.lang) },
                { _id: 'registeredManually', label: 'Registered manually'.translate(this.props.lang) },
                { _id: 'swish', label: 'Swish'.translate(this.props.lang) },
                { _id: 'stripe', label: 'Stripe'.translate(this.props.lang) },
                // { _id: 'payson', label: 'Payson'.translate(this.props.lang) },
                { _id: 'freeOfCharge_older85', label: 'Free of charge - Older 85'.translate(this.props.lang) },
                { _id: 'freeOfCharge_under18', label: 'Free of charge - Under 18'.translate(this.props.lang) },
                // { _id: 'freeOfCharge_under18child', label: 'Free of charge - Under 18 (child)'.translate(this.props.lang) },
                { _id: 'freeOfCharge_under20', label: 'Free of charge - Under 20'.translate(this.props.lang) },
                { _id: 'freeOfCharge_under23', label: 'Free of charge - Under 23'.translate(this.props.lang) }

            ],
            clinicians: [
                { _id: 'unassigned', label: 'Unassigned'.translate(this.props.lang) }
            ],
            statusUpdateReasons: [],
        };
    }



    resetFilters = (ids = [], callback) => {
        let initFilters = [
            { id: 'created', label: 'Created'.translate(this.props.lang), value: { from: null, to: null } },
            { id: 'paymentDate', label: 'Payment date'.translate(this.props.lang), value: { from: null, to: null } },
            { id: 'status', label: 'Status'.translate(this.props.lang), value: [] },
            { id: 'price', label: 'Price'.translate(this.props.lang), value: { from: null, to: null } },
            { id: 'visitDate', label: 'Visit Date'.translate(this.props.lang), value: { from: null, to: null } },
            { id: 'visitStatus', label: 'Visit Status'.translate(this.props.lang), value: [] },
            { id: 'visitReasons', label: 'Visit Reasons'.translate(this.props.lang), value: [] },
            { id: 'paymentMethods', label: 'Payment Methods'.translate(this.props.lang), value: [] },
            { id: 'clinicians', label: 'Clinicians'.translate(this.props.lang), value: [] },
            { id: 'statusUpdateReasons', label: 'Status update reasons'.translate(this.props.lang), value: [] },
        ];

        if (!ids?.length) {
            this.setState({ filters: initFilters, selectedSelectionId: null }, () => {
                this.setValue();
                if (callback) {
                    callback();
                }
            });
        } else {
            let filters = this.state.filters;
            filters = filters.map(filter => {
                if (ids.includes(filter.id)) {
                    return { ...filter, value: initFilters.find(f => f.id === filter.id).value };
                }
                return filter;
            });
            this.setState({ filters, selectedSelectionId: null, showFilters: [] }, () => {
                this.setValue();
                if (callback) {
                    callback();
                }
            });
        }
    }

    getClinicians = () => {
        const clinicId = this.props.selectedClinic;
        if (!clinicId) return;

        this.setState({ clinicians: [] }, () => {
            fetch(API_ENDPOINT + `/data/calendar/doctors/${clinicId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(parseJSON).then(({ result, status }) => {
                if (result?.clinicians?.length) {
                    let clinicians = result?.clinicians?.map(clinician => {
                        return {
                            _id: clinician._id,
                            label: clinician.name
                        }
                    });
                    this.setState({ clinicians: [{ _id: 'unassigned', label: 'Unassigned'.translate(this.props.lang) }, ...clinicians] });
                }
            })
        });
    }
    getReasons = () => {
        const groupData = this.getGroupData();
        const clinicId = this.props.selectedClinic;
        if (!groupData || !clinicId) return;
        const cancellationAndRefundSettings = groupData?.paymentSettings?.cancellationAndRefundSettings?.[clinicId] || null;
        const cancellationReasons = cancellationAndRefundSettings?.cancellationReasons || [];
        let statusUpdateReasons = [];
        if (cancellationReasons?.length) {
            statusUpdateReasons = cancellationReasons.map((reason, rIdx) => {
                return {
                    _id: reason?.[this.props.lang] || reason?.se,
                    label: reason?.[this.props.lang] || reason?.se
                }
            });
        }
        this.setState({ statusUpdateReasons })

    }

    get = () => {
        this.getVisitReasons();
        this.getCustomSelections();
        this.getClinicians();
        this.getReasons();


        const EXTENDED_PAYMENT_MANAGEMENT = this.props.EXTENDED_PAYMENT_MANAGEMENT || false;

        if (EXTENDED_PAYMENT_MANAGEMENT) {
            let statuses = [
                { _id: 'unpaid', label: 'Unpaid'.translate(this.props.lang) },
                { _id: 'paid', label: 'Paid'.translate(this.props.lang) },
                { _id: 'refunded', label: 'Refunded'.translate(this.props.lang) },
                { _id: 'partially_refunded', label: 'Partially Refunded'.translate(this.props.lang) },
                { _id: 'refund_requested', label: 'Refund Requested'.translate(this.props.lang) },
                { _id: 'refund_pending', label: 'Refund Pending'.translate(this.props.lang) },
                { _id: 'refund_failed', label: 'Refund Failed'.translate(this.props.lang) },
                { _id: 'payment_cancelled', label: 'Payment cancelled'.translate(this.props.lang) },
                { _id: 'case_cancelled', label: 'Case cancelled'.translate(this.props.lang) },
                { _id: 'payment_cancellation_requested', label: 'Payment cancellation requested'.translate(this.props.lang) },
                { _id: 'early_cancellation', label: 'Early cancellation'.translate(this.props.lang) },
                { _id: 'late_cancellation', label: 'Late cancellation'.translate(this.props.lang) }
            ];
            this.setState({ statuses });
        }
    }

    getVisitReasons = () => {
        const groupId = this.props.selectedGroup;

        fetch(API_ENDPOINT + `/api/payments/visit-reasons/${groupId}`, {
            method: 'GET',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            }
        }).then(res => res.json()).then((result) => {
            if (result?.visitReasons) {
                let visitReasons = result.visitReasons;
                let groupedVisitReasons = {};
                let _visitReasons = [];
                for (let i = 0; i < visitReasons.length; i++) {
                    let key = visitReasons[i]?.type === 'revisit' ? 'revisit' : `referral_${visitReasons[i]?.wayOfScheduling}`;
                    if (!groupedVisitReasons[key]) {
                        groupedVisitReasons[key] = [];
                    }
                    groupedVisitReasons[key].push(visitReasons[i]);
                }
                for (var key in groupedVisitReasons) {
                    groupedVisitReasons[key] = groupedVisitReasons[key].sort((a, b) => a.label.localeCompare(b.label));
                }
                for (var key in groupedVisitReasons) {
                    let mainLabel = key === "referral_webBooking" ? 'Web booking'.translate(this.props.lang) :
                        key === "referral_bookingByClinic" ? 'Booking by clinic'.translate(this.props.lang) :
                            key === "referral_dropIn" ? 'Drop-in'.translate(this.props.lang) :
                                key === "revisit" ? 'Revisit'.translate(this.props.lang) :
                                    key;
                    _visitReasons = [..._visitReasons, { key: key, mainLabel: mainLabel }, ...groupedVisitReasons[key]];
                }
                this.setState({ visitReasons: visitReasons, _visitReasons: _visitReasons });
            }
        })
    }

    componentDidMount() {
        this.resetFilters();
        this.get();


        document.addEventListener('mousedown', this.handleClickOutside);



    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    handleClickOutside = (event) => {
        if (this.dropdownRef?.current && !this.dropdownRef?.current?.contains(event?.target)) {
            this.setState({ dropdown: null });
        }
        if (this.showFilterRef?.current && !this.showFilterRef?.current?.contains(event?.target)) {
            this.setState({ showFilters: [] });
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.EXTENDED_PAYMENT_MANAGEMENT !== this.props.EXTENDED_PAYMENT_MANAGEMENT) {
            this.get();
        }
        if (this.state.dropdown?.id !== prevState?.dropdown?.id) {
            this.adjustDropdownWidth();
        }
    }
    adjustDropdownWidth = () => {
        try {
            if (['created', 'visitDate', 'price', 'paymentDate'].includes(this.state.dropdown?.id)) {
                const element = this.dropdownRef?.current?.firstChild;
                const elementScrollWidth = element?.scrollWidth || 0;
                const elementOffsetWidth = element?.offsetWidth || 0;
                const dropdownOffsetWidth = this.dropdownRef?.current?.offsetWidth || 0;
                if (elementScrollWidth > dropdownOffsetWidth) {
                    this.dropdownRef?.current?.style?.setProperty('width', `${elementScrollWidth + 20}px`, 'important');
                }
            }
        } catch (error) {
            console.error('Error adjusting dropdown width:', error);
        }

    }

    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        const groupData = selectedGroupIdx > -1 ? this.props.uData?.clinicGroups?.[selectedGroupIdx] : null;
        return groupData;
    }

    checkIfFilterValueExists = (filter) => {
        const value = filter?.value;
        if (value?.from || value?.to) {
            return true;
        } else if (value?.length) {
            return true;
        }
        return false;
    }
    prepareDataCustomSelection = (customSelection = null) => {
        const filters = this.state.filters;
        let check = false;
        for (let i = 0; i < filters.length; i++) {
            if (this.checkIfFilterValueExists(filters[i])) {
                check = true;
                break;
            }
        }
        if (!check) {
            this.setState({ error: 'Please select at least one filter'.translate(this.props.lang) });
            return;
        }
        const _filters = filters?.map(item => {
            return {
                id: item.id,
                value: item.value
            }
        })
        let saveCustomSelectionModal = {
            filters: _filters,
            name: ''
        };
        if (customSelection?._id) {
            saveCustomSelectionModal._id = customSelection._id;
            saveCustomSelectionModal.name = customSelection?.name;
        }
        this.setState({
            saveCustomSelectionModal,
            updateOrInsertCustomSelectionModal: null
        });
    }
    saveCustomSelection = () => {
        let data = {
            ...this.state.saveCustomSelectionModal,
            clinicId: this.props.selectedClinic,
            groupId: this.props.selectedGroup
        };
        if (!data) return;

        const id = data?._id?.length === 24 ? data._id : 'new';
        delete data._id;
        this.setState({ loadingSaveCustomSelection: true }, () => {
            const api = `/api/payments/custom-selection/${id}`;

            fetch(API_ENDPOINT + api, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                this.setState({ saveCustomSelectionModal: null, loadingSaveCustomSelection: false });
                this.getCustomSelections(false, () => {
                    if (result?._id && this.setCustomSelection) {
                        this.setCustomSelection([result._id]);
                    }
                });

            })
        })


    }
    getCustomSelections = (initial = false, callback) => {
        const clinicId = this.props.selectedClinic;
        if (!clinicId) return;

        const api = `/api/payments/custom-selection/${clinicId}`;

        this.setState({ customSelections: [] }, () => {
            fetch(API_ENDPOINT + api, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(parseJSON).then(({ result, status }) => {
                if (result?.length) {
                    this.setState({ customSelections: result }, () => {
                        if (callback) {
                            callback();
                        }
                    });
                }
            })
        })

    }
    deleteCustomSelection = (id) => {
        if (!id) return;

        const api = `/api/payments/custom-selection/${id}`;

        fetch(API_ENDPOINT + api, {
            method: 'DELETE',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            }
        }).then(parseJSON).then(({ result, status }) => {
            this.setState({ deleteCustomSelectionModal: null }, () => {
                this.getCustomSelections();
            });
        })
    }
    setValue = () => {
        const filters = this.state.filters ?? [];
        let data = {};
        for (let i = 0; i < filters.length; i++) {
            const filter = filters[i];
            if (this.checkIfFilterValueExists(filter)) {
                data[filter.id] = filter.value;
            }
        }

        if (this.props.onChange) {
            this.props.onChange(data);
        }
    }
    checkShowFilters = (filter, userPaymentPermissions) => {
        if (!filter || !filter.id) return false;
        let show = true;
        const EXTENDED_PAYMENT_MANAGEMENT = this.props.EXTENDED_PAYMENT_MANAGEMENT || false;

        if (filter.id === 'clinicians' && !userPaymentPermissions?.showCliniciansFilter) {
            show = false;
        }
        if (filter.id === 'statusUpdateReasons' && !EXTENDED_PAYMENT_MANAGEMENT) {
            show = false;
        }


        return show;
    }

    render() {
        const EXTENDED_PAYMENT_MANAGEMENT = this.props.EXTENDED_PAYMENT_MANAGEMENT || false;

        const tsNow = Math.floor(new Date().getTime() / 1000);
        const dateNow = this.props.getStringDateTs(tsNow, this.props.dateFormat)

        const filterValue = (filter) => {
            const check = this.checkIfFilterValueExists(filter);
            if (!check) return null;
            const from = filter?.value?.from;
            const to = filter?.value?.to;
            const result = from !== to ? `${from} - ${to}` : from;
            let values = [];
            const value = filter?.value;
            if (filter.id === 'status') {
                values = this.state.statuses.filter(item => value?.includes(item._id))?.map(item => item.label);
            } else if (filter.id === 'visitStatus') {
                values = this.state.visitStatuses.filter(item => value?.includes(item._id))?.map(item => item.label);
            } else if (filter.id === 'visitReasons') {
                values = this.state._visitReasons.filter(item => value?.includes(item._id))?.map(item => item.label);
            } else if (filter.id === 'paymentMethods') {
                values = this.state.paymentMethods.filter(item => value?.includes(item._id))?.map(item => item.label);
            } else if (filter.id === 'clinicians') {
                values = this.state.clinicians.filter(item => value?.includes(item._id))?.map(item => item.label);
            } else if (filter.id === 'statusUpdateReasons') {
                values = this.state.statusUpdateReasons.filter(item => value?.includes(item._id))?.map(item => item.label);
            }
            const showFilters = this.state.showFilters || [];
            const show = showFilters.includes(filter.id) || ['created', 'visitDate', 'price', 'paymentDate'].includes(filter.id);
            return (
                <div className='custom-filter-value' style={['status', 'visitStatus', 'visitReasons', 'paymentMethods', 'clinicians', 'statusUpdateReasons']?.includes(filter?.id) && show ? { borderTop: 'none' } : {}}>
                    {
                        show ?
                            ['created', 'visitDate', 'price', 'paymentDate']?.includes(filter?.id) ?
                                <span>{result}</span>
                                :
                                ['status', 'visitStatus', 'visitReasons', 'paymentMethods', 'clinicians', 'statusUpdateReasons']?.includes(filter?.id) ?
                                    <div className='custom-filter-multiple-values' ref={this.showFilterRef}>
                                        {values.map((item, idx) => <span key={idx}>{item}</span>)}
                                        {/* <div className='custom-filter-value-hide' onClick={(e) => {
                                            e.stopPropagation();
                                            let _showFilters = showFilters.filter(el => el !== filter.id);
                                            this.setState({ showFilters: _showFilters });
                                        }}>
                                            <span className='custom-filter-value-placeholder'>{'Hide filters'.translate(this.props.lang)}</span>
                                        </div> */}
                                    </div>
                                    :
                                    null
                            :
                            <div onClick={(e) => {
                                e.stopPropagation();
                                this.setState({ showFilters: [...showFilters, filter.id] });
                            }}>
                                <span className='custom-filter-value-placeholder'>{'Show filters'.translate(this.props.lang)}</span>
                            </div>
                    }
                </div>
            )
        }
        const dropdownItems = this.state.dropdown?.items?.filter(item => !this.state.dropdown?.search || item?.label?.toLowerCase()?.includes(this.state.dropdown?.search?.toLowerCase()) || item?.mainLabel) ?? [];
        const saveCustomSelectionModal = this.state.saveCustomSelectionModal;
        const userPaymentPermissions = this.props.userPaymentPermissions;
        return (
            <div className='payments-custom-filters-wrap'>
                <div className='custom-filters-wrap'>
                    {
                        this.state.filters?.filter(filter => this.checkShowFilters(filter, userPaymentPermissions)).map((filter, index) => {
                            const valueExists = this.checkIfFilterValueExists(filter);
                            return (
                                <div
                                    key={index}
                                    className={valueExists ? 'custom-filter-item' : 'custom-filter-item'}
                                    onClick={() => {
                                        let dropdown = this.state.dropdown;
                                        if (dropdown !== filter.id) {
                                            dropdown = {
                                                id: filter.id,
                                                search: ''
                                            };
                                            if (['created', 'visitDate', 'price', 'paymentDate'].includes(filter.id)) {
                                                dropdown.from = filter?.value?.from || null;
                                                dropdown.to = filter?.value?.to || null;
                                            } else if (['status', 'visitStatus', 'visitReasons', 'paymentMethods', 'clinicians', 'statusUpdateReasons'].includes(filter.id)) {
                                                dropdown.value = filter?.value || null;
                                                if (filter.id === 'status') {
                                                    dropdown.items = this.state.statuses || [];
                                                } else if (filter.id === 'visitStatus') {
                                                    dropdown.items = this.state.visitStatuses || [];
                                                } else if (filter.id === 'visitReasons') {
                                                    dropdown.items = this.state._visitReasons || [];
                                                } else if (filter.id === 'paymentMethods') {
                                                    dropdown.items = this.state.paymentMethods || [];
                                                } else if (filter.id === 'clinicians') {
                                                    dropdown.items = this.state.clinicians || [];
                                                } else if (filter.id === 'statusUpdateReasons') {
                                                    dropdown.items = this.state.statusUpdateReasons || [];
                                                } else {
                                                    dropdown.items = [];
                                                }
                                            }
                                        } else {
                                            dropdown = null;
                                        }
                                        this.setState({ dropdown });
                                    }}
                                >
                                    <div className='custom-filter-content'>
                                        <div>
                                            {valueExists ? <div className='remove-filter' onClick={(e) => {
                                                e.stopPropagation();
                                                this.resetFilters([filter.id]);
                                            }}>&times;</div> : <Isvg src={addIcon} />}
                                        </div>
                                        <h6>{filter.label}</h6>

                                    </div>
                                    {filterValue(filter)}
                                    {/* Render filter input based on filter type */}

                                    {
                                        filter.id === this.state.dropdown?.id ?
                                            ['created', 'visitDate', 'paymentDate'].includes(filter.id) ?
                                                <div className='custom-filters-dropdown-wrap' ref={this.dropdownRef} onClick={e => e.stopPropagation()}>
                                                    <div className='date-range-dropdown'>
                                                        <DatePicker
                                                            // label={'Date'.translate(this.props.lang)}
                                                            value={this.state.dropdown?.from}
                                                            // holidayEvents={this.state.holidayEvents}
                                                            lang={this.props.lang}
                                                            onChange={(date) => {
                                                                let dropdown = this.state.dropdown;
                                                                dropdown.from = date;
                                                                const { from, to } = dropdown;
                                                                if (!to || new Date(from) > new Date(to)) {
                                                                    dropdown.to = from;
                                                                }
                                                                this.setState({ dropdown });
                                                            }}
                                                        />
                                                        {'-'}
                                                        <DatePicker
                                                            // label={'Date'.translate(this.props.lang)}
                                                            value={this.state.dropdown?.to}
                                                            // holidayEvents={this.state.holidayEvents}
                                                            lang={this.props.lang}
                                                            minDate={new Date(this.state.dropdown?.from)}
                                                            onChange={(date) => {
                                                                let dropdown = this.state.dropdown;
                                                                dropdown.to = date;
                                                                this.setState({ dropdown });
                                                            }}
                                                        />
                                                        <Button
                                                            color='primary'
                                                            disabled={!this.state.dropdown?.from || !this.state.dropdown?.to || (this.state.dropdown?.from === filter?.value?.from && this.state.dropdown?.to === filter?.value?.to)}
                                                            onClick={() => {
                                                                let filters = this.state.filters;
                                                                let index = filters.findIndex(f => f.id === filter.id);
                                                                if (index > -1 && typeof filters[index]?.value === 'object') {
                                                                    filters[index].value['from'] = this.state.dropdown?.from;
                                                                    filters[index].value['to'] = this.state.dropdown?.to;
                                                                    this.setState({ filters }, () => {
                                                                        this.setState({ dropdown: null })
                                                                        this.setValue();
                                                                    });
                                                                }
                                                            }}
                                                        >
                                                            {'Apply'.translate(this.props.lang)}
                                                        </Button>
                                                    </div>

                                                </div>
                                                :
                                                ['price'].includes(filter.id) ?
                                                    <div className='custom-filters-dropdown-wrap' ref={this.dropdownRef} onClick={e => e.stopPropagation()}>
                                                        <div className='date-range-dropdown'>
                                                            <Input
                                                                type='text'
                                                                value={this.state.dropdown?.from}
                                                                onChange={(e) => {
                                                                    const value = e.target.value.replace(/\D/g, "");
                                                                    let dropdown = this.state.dropdown;
                                                                    dropdown.from = Number(value);
                                                                    const { from, to } = dropdown;
                                                                    if (from > to) {
                                                                        dropdown.to = from;
                                                                    }
                                                                    this.setState({ dropdown });
                                                                }}
                                                            />
                                                            {'-'}
                                                            <Input
                                                                type='text'
                                                                value={this.state.dropdown?.to}
                                                                onChange={(e) => {
                                                                    const value = e.target.value.replace(/\D/g, "");
                                                                    let dropdown = this.state.dropdown;
                                                                    dropdown.to = Number(value);
                                                                    this.setState({ dropdown });
                                                                }}
                                                            />

                                                            <Button
                                                                color='primary'
                                                                disabled={
                                                                    (this.state.dropdown?.from || this.state.dropdown?.from === 0)
                                                                        && (this.state.dropdown?.to || this.state.dropdown?.to === 0)
                                                                        && (this.state.dropdown?.from !== filter?.value?.from || this.state.dropdown?.to !== filter?.value?.to)
                                                                        ? false : true
                                                                }
                                                                onClick={() => {
                                                                    let filters = this.state.filters;
                                                                    let index = filters.findIndex(f => f.id === filter.id);
                                                                    if (index > -1 && typeof filters[index]?.value === 'object') {
                                                                        let { from, to } = this.state.dropdown;
                                                                        if (to < from) {
                                                                            to = from;
                                                                        }
                                                                        filters[index].value['from'] = from;
                                                                        filters[index].value['to'] = to;
                                                                        this.setState({ filters }, () => {
                                                                            this.setState({ dropdown: null })
                                                                            this.setValue();
                                                                        });
                                                                    }
                                                                }}
                                                            >
                                                                {'Apply'.translate(this.props.lang)}
                                                            </Button>
                                                        </div>

                                                    </div>
                                                    :
                                                    ['status', 'visitStatus', 'visitReasons', 'paymentMethods', 'clinicians', 'statusUpdateReasons'].includes(filter.id) ?
                                                        <div className='custom-filters-dropdown-wrap' ref={this.dropdownRef} onClick={e => e.stopPropagation()} style={{ width: 250 }}>
                                                            <div className='list-filter-dropdown'>
                                                                {
                                                                    dropdownItems?.length ?
                                                                        <div className='list-filter-dropdown-select-all'>
                                                                            <Checkbox
                                                                                onChange={(e) => {
                                                                                    let value = e.target.checked;
                                                                                    const allItems = dropdownItems ?? [];
                                                                                    let selectedValues = [];
                                                                                    selectedValues = allItems?.filter(item => item?._id).map(item => item?._id);
                                                                                    let dropdown = this.state.dropdown || {};
                                                                                    dropdown.value = value ? selectedValues : [];
                                                                                    if (filter.id === 'paymentMethods') {
                                                                                        if (dropdown?.value?.includes('freeOfCharge_under18') && !dropdown?.value?.includes('freeOfCharge_under18child')) {
                                                                                            dropdown.value.push('freeOfCharge_under18child');
                                                                                        } else if (!dropdown?.value?.includes('freeOfCharge_under18') && dropdown?.value?.includes('freeOfCharge_under18child')) {
                                                                                            dropdown.value = dropdown.value.filter(id => id !== 'freeOfCharge_under18child');
                                                                                        }
                                                                                        if (dropdown?.value?.includes('invoice') && !dropdown?.value?.includes('invoicePending')) {
                                                                                            dropdown.value.push('invoicePending');
                                                                                        } else if (!dropdown?.value?.includes('invoice') && dropdown?.value?.includes('invoicePending')) {
                                                                                            dropdown.value = dropdown.value.filter(id => id !== 'invoicePending');
                                                                                        }
                                                                                    }
                                                                                    this.setState({ dropdown });
                                                                                }}
                                                                                checked={dropdownItems?.filter(item => item?._id)?.map(item => this.state.dropdown?.value?.includes(item?._id))?.every(Boolean)}
                                                                                label={'Select all/none'.translate(this.props.lang)}

                                                                            />
                                                                        </div>
                                                                        :
                                                                        null
                                                                }

                                                                <div className='list-filter-dropdown-search'>
                                                                    <Input type='text' placeholder={`${'Search'.translate(this.props.lang)}`} value={this.state.dropdown?.search} onChange={(e) => {
                                                                        let dropdown = this.state.dropdown;
                                                                        dropdown.search = e.target.value;
                                                                        this.setState({ dropdown });
                                                                    }} />
                                                                </div>
                                                                {
                                                                    dropdownItems?.length === 0 ?
                                                                        <div className='no-available-options-message'>{'No available options!'.translate(this.props.lang)}</div>
                                                                        :
                                                                        null
                                                                }
                                                                <div style={{ maxHeight: '50vh', overflowY: 'auto' }}>
                                                                    {
                                                                        dropdownItems?.map((item, idx) => {
                                                                            let mainLabel = item?.mainLabel;
                                                                            if (mainLabel) {
                                                                                return (
                                                                                    <div key={idx} className='list-filter-dropdown-item'>
                                                                                        <strong style={{ fontSize: 12, fontWeight: 600 }}>{mainLabel}</strong>
                                                                                    </div>
                                                                                );
                                                                            } else {
                                                                                return (
                                                                                    <div key={idx} className='list-filter-dropdown-item'>
                                                                                        <Checkbox
                                                                                            onChange={(e) => {
                                                                                                let dropdown = this.state.dropdown || {};
                                                                                                let value = [...dropdown.value];
                                                                                                if (value?.includes(item?._id)) {
                                                                                                    value = value.filter(id => id !== item?._id);
                                                                                                } else {
                                                                                                    value.push(item?._id);
                                                                                                }
                                                                                                dropdown.value = [...value];
                                                                                                if (filter.id === 'paymentMethods') {
                                                                                                    if (dropdown.value.includes('freeOfCharge_under18') && !dropdown.value.includes('freeOfCharge_under18child')) {
                                                                                                        dropdown.value.push('freeOfCharge_under18child');
                                                                                                    } else if (!dropdown.value.includes('freeOfCharge_under18') && dropdown.value.includes('freeOfCharge_under18child')) {
                                                                                                        dropdown.value = dropdown.value.filter(id => id !== 'freeOfCharge_under18child');
                                                                                                    }
                                                                                                    if (dropdown?.value?.includes('invoice') && !dropdown?.value?.includes('invoicePending')) {
                                                                                                        dropdown.value.push('invoicePending');
                                                                                                    } else if (!dropdown?.value?.includes('invoice') && dropdown?.value?.includes('invoicePending')) {
                                                                                                        dropdown.value = dropdown.value.filter(id => id !== 'invoicePending');
                                                                                                    }
                                                                                                }
                                                                                                this.setState({ dropdown });
                                                                                            }}
                                                                                            checked={this.state.dropdown?.value?.includes(item?._id)}
                                                                                            label={item?.label}
                                                                                        />
                                                                                    </div>
                                                                                )
                                                                            }

                                                                        })
                                                                    }
                                                                </div>
                                                                <Button
                                                                    color='primary'
                                                                    disabled={this.state.dropdown?.value === filter.value}
                                                                    onClick={() => {
                                                                        let filters = this.state.filters;
                                                                        let index = filters.findIndex(f => f.id === filter.id);
                                                                        if (index > -1 && typeof filters[index]?.value === 'object') {
                                                                            let { value } = this.state.dropdown;
                                                                            filters[index].value = value;
                                                                            this.setState({ filters }, () => {
                                                                                this.setState({ dropdown: null })
                                                                                this.setValue();
                                                                            });
                                                                        }
                                                                    }}
                                                                >
                                                                    {'Apply'.translate(this.props.lang)}
                                                                </Button>
                                                            </div>
                                                        </div>

                                                        :
                                                        null
                                            :
                                            null
                                    }
                                </div>
                            )
                        })
                    }



                </div>
                <div className='global-filters-wrap'>

                    <div className='custom-selection-wrap'>

                        <CustomCalendarFilterSelect
                            placeholder={'Custom selection'.translate(this.props.lang)}
                            actionButton={{
                                icon: saveIcon,
                                onClick: () => {
                                    let selectedSelectionId = this.state.selectedSelectionId;
                                    // console.log('selectedSelectionId', selectedSelectionId, this.state.customSelections)
                                    let customSelection = this.state.customSelections.find(obj => obj._id === selectedSelectionId);
                                    if (customSelection?._id) {
                                        this.setState({ updateOrInsertCustomSelectionModal: customSelection });
                                    } else {
                                        this.prepareDataCustomSelection();

                                    }
                                }
                            }}
                            inputStyle={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                            items={this.state.customSelections?.map((item) => {
                                return {
                                    label: item?.name,
                                    value: item._id
                                }
                            })}
                            onChange={(values) => {
                                const value = values?.[0];


                                this.resetFilters(null, () => {
                                    let customSelection = this.state.customSelections.find(obj => obj._id === value);

                                    if (customSelection?.filters) {
                                        let filters = this.state.filters;
                                        for (let i = 0; i < filters.length; i++) {
                                            let _filter = customSelection?.filters?.find(el => el.id === filters[i].id);
                                            if (_filter) {
                                                filters[i].value = _filter.value;
                                            }
                                        }
                                        this.setState({ filters, selectedSelectionId: value }, () => {
                                            this.setValue();
                                        });
                                    }
                                })
                            }}
                            singleSelect={true}
                            registerSetData={(setCustomSelection) => this.setCustomSelection = setCustomSelection}
                            removeHandler={(value) => {
                                let customSelection = this.state.customSelections.find(obj => obj._id === value);
                                if (customSelection) {
                                    this.setState({ deleteCustomSelectionModal: customSelection });
                                }
                            }}
                            lang={this.props.lang}
                        />
                    </div>
                    <div
                        className='clear-filters-wrap'
                        onClick={() => this.resetFilters(null, () => {
                            if (this.setCustomSelection) {
                                this.setCustomSelection([]);
                            }
                        })}
                    >
                        {'Clear filters'.translate(this.props.lang)}
                    </div>
                </div>
                {
                    this.state.deleteCustomSelectionModal ?
                        <DeleteModal
                            zIndex={99999}
                            lang={this.props.lang}
                            isOpen={this.state.deleteCustomSelectionModal}
                            toggle={() => this.setState({ deleteCustomSelectionModal: null })}
                            handler={() => {
                                this.deleteCustomSelection(this.state.deleteCustomSelectionModal?._id);
                            }}
                        >
                            {'Delete custom selection'.translate(this.props.lang)} <strong>{this.state.deleteCustomSelectionModal && this.state.deleteCustomSelectionModal.name}</strong>?
                        </DeleteModal>
                        :
                        null
                }

                {
                    this.state.updateOrInsertCustomSelectionModal ?
                        < InfoModal
                            zIndex={99999}
                            isOpen={this.state.updateOrInsertCustomSelectionModal}
                            header={'Info'.translate(this.props.lang)}
                            info={'Do you want to update selected custom selection or create new?'.translate(this.props.lang)}
                            buttons={[
                                <Button color='primary' onClick={() => {
                                    let customSelection = { ...this.state.updateOrInsertCustomSelectionModal };
                                    this.prepareDataCustomSelection(customSelection);
                                }}>{'Update'.translate(this.props.lang)}</Button>,
                                <Button color='primary' onClick={() => {
                                    this.prepareDataCustomSelection();
                                }}>{'Create new'.translate(this.props.lang)}</Button>,
                                <Button color='primary' onClick={() => {
                                    this.setState({ updateOrInsertCustomSelectionModal: null })
                                }}>{'Close'.translate(this.props.lang)}</Button>

                            ]}
                        />
                        :
                        null
                }
                {
                    saveCustomSelectionModal ?
                        <Modal
                            isOpen={saveCustomSelectionModal}
                            toggle={() => this.setState({ saveCustomSelectionModal: null })}
                            className='save-custom-selection-modal'
                            centered
                            zIndex={99999}
                        >
                            <ModalHeader toggle={() => this.setState({ saveCustomSelectionModal: null })}>
                                {'Save custom selection'.translate(this.props.lang)}
                            </ModalHeader>
                            <ModalBody>
                                <FormGroup>
                                    <Label>{'Name your selection'.translate(this.props.lang)}</Label>
                                    <Input
                                        type='text'
                                        value={saveCustomSelectionModal?.name}
                                        onChange={(e) => {
                                            let value = e.target.value;
                                            let data = saveCustomSelectionModal;
                                            data.name = value;
                                            this.setState({ saveCustomSelectionModal: data });
                                        }}
                                    />
                                </FormGroup>

                                <div className='custom-selection-preview'>
                                    <div className='custom-selection-preview-item'>
                                        <div className='custom-selection-preview-item-title'>
                                            {'Created'.translate(this.props.lang)}:
                                        </div>
                                        {
                                            saveCustomSelectionModal?.filters?.find(el => el.id === 'created')?.value?.from ?
                                                <div className='custom-selection-preview-item-value'>
                                                    {'From'.translate(this.props.lang)}: {saveCustomSelectionModal?.filters?.find(el => el.id === 'created')?.value?.from} <br />{'To'.translate(this.props.lang)}: {saveCustomSelectionModal?.filters?.find(el => el.id === 'created')?.value?.to}
                                                </div>
                                                :
                                                <div className='custom-selection-preview-item-value-not-selected'>{'Filter not selected.'.translate(this.props.lang)}</div>
                                        }
                                    </div>
                                    <div className='custom-selection-preview-item'>
                                        <div className='custom-selection-preview-item-title'>
                                            {'Payment Date'.translate(this.props.lang)}:
                                        </div>
                                        {
                                            saveCustomSelectionModal?.filters?.find(el => el.id === 'paymentDate')?.value?.from ?
                                                <div className='custom-selection-preview-item-value'>
                                                    {'From'.translate(this.props.lang)}: {saveCustomSelectionModal?.filters?.find(el => el.id === 'paymentDate')?.value?.from} <br />{'To'.translate(this.props.lang)}: {saveCustomSelectionModal?.filters?.find(el => el.id === 'paymentDate')?.value?.to}
                                                </div>
                                                :
                                                <div className='custom-selection-preview-item-value-not-selected'>{'Filter not selected.'.translate(this.props.lang)}</div>
                                        }
                                    </div>
                                    <div className='custom-selection-preview-item'>
                                        <div className='custom-selection-preview-item-title'>
                                            {'Status'.translate(this.props.lang)}:
                                        </div>
                                        {
                                            saveCustomSelectionModal?.filters?.find(el => el.id === 'status')?.value?.length ?
                                                <div className='custom-selection-preview-item-value'>
                                                    {
                                                        saveCustomSelectionModal?.filters?.find(el => el.id === 'status')?.value?.map((status, index) => {
                                                            return (
                                                                <div className='custom-selection-preview-item-value' key={index}>
                                                                    {this.state.statuses.find(obj => obj._id === status)?.label || status}
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                                :
                                                <div className='custom-selection-preview-item-value-not-selected'>{'Filter not selected.'.translate(this.props.lang)}</div>
                                        }
                                    </div>
                                    <div className='custom-selection-preview-item'>
                                        <div className='custom-selection-preview-item-title'>
                                            {'Price'.translate(this.props.lang)}:
                                        </div>
                                        {
                                            saveCustomSelectionModal?.filters?.find(el => el.id === 'price')?.value?.from || saveCustomSelectionModal?.filters?.find(el => el.id === 'price')?.value?.to ?
                                                <div className='custom-selection-preview-item-value'>
                                                    {'From'.translate(this.props.lang)}: {saveCustomSelectionModal?.filters?.find(el => el.id === 'price')?.value?.from} <br />{'To'.translate(this.props.lang)}: {saveCustomSelectionModal?.filters?.find(el => el.id === 'price')?.value?.to}
                                                </div>
                                                :
                                                <div className='custom-selection-preview-item-value-not-selected'>{'Filter not selected.'.translate(this.props.lang)}</div>
                                        }
                                    </div>

                                    <div className='custom-selection-preview-item'>
                                        <div className='custom-selection-preview-item-title'>
                                            {'Visit date'.translate(this.props.lang)}:
                                        </div>
                                        {
                                            saveCustomSelectionModal?.filters?.find(el => el.id === 'visitDate')?.value?.from ?
                                                <div className='custom-selection-preview-item-value'>
                                                    {'From'.translate(this.props.lang)}: {saveCustomSelectionModal?.filters?.find(el => el.id === 'visitDate')?.value?.from} <br />{'To'.translate(this.props.lang)}: {saveCustomSelectionModal?.filters?.find(el => el.id === 'visitDate')?.value?.to}
                                                </div>
                                                :
                                                <div className='custom-selection-preview-item-value-not-selected'>{'Filter not selected.'.translate(this.props.lang)}</div>
                                        }
                                    </div>
                                    <div className='custom-selection-preview-item'>
                                        <div className='custom-selection-preview-item-title'>
                                            {'Visit status'.translate(this.props.lang)}:
                                        </div>
                                        {
                                            saveCustomSelectionModal?.filters?.find(el => el.id === 'visitStatus')?.value?.length ?
                                                <div className='custom-selection-preview-item-value'>
                                                    {
                                                        saveCustomSelectionModal?.filters?.find(el => el.id === 'visitStatus')?.value?.map((status, index) => {
                                                            return (
                                                                <div className='custom-selection-preview-item-value' key={index}>
                                                                    {this.state.visitStatuses.find(obj => obj._id === status)?.label || status}
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                                :
                                                <div className='custom-selection-preview-item-value-not-selected'>{'Filter not selected.'.translate(this.props.lang)}</div>
                                        }
                                    </div>
                                    <div className='custom-selection-preview-item'>
                                        <div className='custom-selection-preview-item-title'>
                                            {'Visit reasons'.translate(this.props.lang)}:
                                        </div>
                                        {
                                            saveCustomSelectionModal?.filters?.find(el => el.id === 'visitReasons')?.value?.length ?
                                                <div className='custom-selection-preview-item-value'>
                                                    {
                                                        saveCustomSelectionModal?.filters?.find(el => el.id === 'visitReasons')?.value?.map((reason, index) => {
                                                            return (
                                                                <div className='custom-selection-preview-item-value' key={index}>
                                                                    {this.state.visitReasons.find(obj => obj._id === reason)?.label || reason}
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                                :
                                                <div className='custom-selection-preview-item-value-not-selected'>{'Filter not selected.'.translate(this.props.lang)}</div>
                                        }
                                    </div>
                                    <div className='custom-selection-preview-item'>
                                        <div className='custom-selection-preview-item-title'>
                                            {'Payment methods'.translate(this.props.lang)}:
                                        </div>
                                        {
                                            saveCustomSelectionModal?.filters?.find(el => el.id === 'paymentMethods')?.value?.length ?
                                                <div className='custom-selection-preview-item-value'>
                                                    {
                                                        saveCustomSelectionModal?.filters?.find(el => el.id === 'paymentMethods')?.value?.filter(method => !['freeOfCharge_under18child', 'invoicePending'].includes(method))?.map((method, index) => {
                                                            return (
                                                                <div className='custom-selection-preview-item-value' key={index}>
                                                                    {this.state.paymentMethods.find(obj => obj._id === method)?.label || method}
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                                :
                                                <div className='custom-selection-preview-item-value-not-selected'>{'Filter not selected.'.translate(this.props.lang)}</div>
                                        }
                                    </div>
                                    <div className='custom-selection-preview-item'>
                                        <div className='custom-selection-preview-item-title'>
                                            {'Clinicians'.translate(this.props.lang)}:
                                        </div>
                                        {
                                            saveCustomSelectionModal?.filters?.find(el => el.id === 'clinicians')?.value?.length ?
                                                <div className='custom-selection-preview-item-value'>
                                                    {
                                                        saveCustomSelectionModal?.filters?.find(el => el.id === 'clinicians')?.value?.map((clinician, index) => {
                                                            return (
                                                                <div className='custom-selection-preview-item-value' key={index}>
                                                                    {this.state.clinicians.find(obj => obj._id === clinician)?.label || clinician}
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                                :
                                                <div className='custom-selection-preview-item-value-not-selected'>{'Filter not selected.'.translate(this.props.lang)}</div>
                                        }
                                    </div>
                                    <div className='custom-selection-preview-item'>
                                        <div className='custom-selection-preview-item-title'>
                                            {'Status Update Reasons'.translate(this.props.lang)}:
                                        </div>
                                        {
                                            saveCustomSelectionModal?.filters?.find(el => el.id === 'statusUpdateReasons')?.value?.length ?
                                                <div className='custom-selection-preview-item-value'>
                                                    {
                                                        saveCustomSelectionModal?.filters?.find(el => el.id === 'statusUpdateReasons')?.value?.map((reason, index) => {
                                                            return (
                                                                <div className='custom-selection-preview-item-value' key={index}>
                                                                    {this.state.statusUpdateReasons.find(obj => obj._id === reason)?.label || reason}
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                                :
                                                <div className='custom-selection-preview-item-value-not-selected'>{'Filter not selected.'.translate(this.props.lang)}</div>
                                        }
                                    </div>



                                </div>
                            </ModalBody>
                            <ModalFooter className='modal-footer-buttons-wrap' style={{ justifyContent: 'flex-end' }}>
                                <Button
                                    color="primary"
                                    disabled={!saveCustomSelectionModal?.name?.trim() || this.state.loadingSaveCustomSelection}
                                    onClick={() => {
                                        this.saveCustomSelection();
                                        this.setState({ saveCustomSelectionModal: null });
                                    }}
                                >
                                    {'Save'.translate(this.props.lang)}
                                </Button>
                                <Button color="primary" onClick={() => this.setState({ saveCustomSelectionModal: null })}>{'Close'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.error ?
                        <ErrorModal
                            lang={this.props.lang}
                            isOpen={this.state.error}
                            toggle={() => this.setState({ error: null })}
                            closeButtonText={'Cancel'.translate(this.props.lang)}
                            zIndex={9999}
                        >
                            {this.state.error}
                        </ErrorModal>
                        :
                        null
                }
            </div >
        );
    }
}


export default CustomFilters;